import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

import YouTubeIcon from '@mui/icons-material/YouTube';
import '../style/Footer.css'

export const Footer = () => {
  return (
    <div className='footer'>
      <div className='socialMedia'>
        <FacebookIcon />
        <a href="https://www.instagram.com/dunyamizin_kaderi_ellerimizde?igsh=czM3MjMxZ2ZlcGx6">
          <InstagramIcon />
        </a>
        <a href="https://www.youtube.com/@dunyamizinkaderiellerimizde">
          <YouTubeIcon/>
        </a>
        <h2>Zekai Gümüşdiş Ortaokulu Erasmus+ Projesi Tanıtım Sayfasdır</h2>
        <h3>Tüm hakları saklıdır</h3>


      </div>
      <p>

      </p>

    </div>
  )
}
